import { createServerFn } from "@tanstack/react-start";
import { setResponseHeader } from "@tanstack/react-start/server";
import { readTemplatePreview } from "./template-preview.server";
import { siteContext } from "./site.server";

/** A template's illustrative example page (/use-cases/<slug>/preview/...), never indexed. */
export const loadTemplatePreview = createServerFn({ method: "GET" })
  .validator((input: unknown) => {
    const { slug, page, theme, look, hero } = (input ?? {}) as Record<string, unknown>;
    return {
      slug: typeof slug === "string" && /^[a-z0-9-]{1,80}$/.test(slug) ? slug : "",
      page: typeof page === "string" && page.length <= 200 ? page : "\0",
      theme: typeof theme === "string" ? theme.slice(0, 40) : null,
      look: typeof look === "string" && /^[a-z0-9][a-z0-9-]{0,79}$/.test(look) ? look : null,
      hero: hero === true,
    };
  })
  .handler(async ({ data, context }) => {
    const preview = await readTemplatePreview(
      await siteContext(context),
      data.slug,
      data.page,
      data.theme,
      data.look,
      data.hero,
    );
    if (preview) setResponseHeader("X-Robots-Tag", "noindex");
    return preview;
  });
